import { AnimatePresence, motion } from 'framer-motion';
import { FC, ReactNode } from 'react';

type CrossfadeTextProps = {
  children: ReactNode;
  className?: string;
  textKey: string;
};

export const CrossfadeText: FC<CrossfadeTextProps> = ({ children, className, textKey }) => (
  <AnimatePresence mode="wait">
    <motion.span
      animate={{ opacity: 1, y: 0 }}
      className={className}
      exit={{ opacity: 0, y: -4 }}
      initial={{ opacity: 0, y: 4 }}
      key={textKey}
      transition={{ duration: 0.22, ease: 'easeOut' }}
    >
      {children}
    </motion.span>
  </AnimatePresence>
);
